import React, { useState, useEffect } from 'react';
import { getImportantClientNotes } from '../services/notes';
import './ImportantNotesPopup.css';

export default function ImportantNotesPopup({ clientId, clientName, onClose }) {
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadNotes = async () => {
      try {
        setLoading(true);
        const data = await getImportantClientNotes(clientId);
        setNotes(data);
      } catch (error) {
        console.error('Error loading important notes:', error);
      } finally {
        setLoading(false);
      }
    };
    loadNotes();
  }, [clientId]);

  if (loading) {
    return (
      <div className="important-notes-overlay">
        <div className="important-notes-popup">
          <div className="loading-state">Loading notes...</div>
        </div>
      </div>
    );
  }

  if (notes.length === 0) {
    return null;
  }

  return (
    <div className="important-notes-overlay" onClick={onClose}>
      <div className="important-notes-popup" onClick={(e) => e.stopPropagation()}>
        <div className="popup-header">
          <div className="popup-title-section">
            <h2>⚠️ Important Notes</h2>
            <p className="popup-subtitle">Client: {clientName}</p>
          </div>
          <button className="btn-close-popup" onClick={onClose}>×</button>
        </div>
        <div className="popup-content">
          <div className="important-notes-list">
            {notes.map((note) => (
              <div key={note.id} className="important-note-item">
                <div className="note-date">
                  {new Date(note.created_at).toLocaleDateString()} {new Date(note.created_at).toLocaleTimeString()}
                </div>
                <div className="note-text">
                  {note.note.split('\n').map((line, index) => (
                    <p key={index}>{line || '\u00A0'}</p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="popup-footer">
          <button className="btn-acknowledge" onClick={onClose}>
            Acknowledge
          </button>
        </div>
      </div>
    </div>
  );
}
